import { render, staticRenderFns } from "./HealthWarnings.vue?vue&type=template&id=ad601ee2&"
import script from "./HealthWarnings.vue?vue&type=script&lang=js&"
export * from "./HealthWarnings.vue?vue&type=script&lang=js&"
import style0 from "./HealthWarnings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports